import classNames from 'classnames'
import React from 'react'
import { Card, Column, Grid } from 'src/components/framework/ui'
import { SectionHeader } from 'src/components/framework/ui/section-header'
import { useStockReportContext } from 'src/contexts/stock-report.context'
import { makeSecurityLink } from 'src/shared/utils'

export const NewsList: React.FC = () => {
  const { report } = useStockReportContext()
  const { security } = report

  return (
    <>
      <Grid>
        <Column>
          <SectionHeader>Latest News for {security.ticker}</SectionHeader>
        </Column>
        <Column shrink={'shrink'}>
          <a href={`${makeSecurityLink(security)}/news`}>View all news</a>
        </Column>
      </Grid>
      <Card variants={['outlined']} className={'stk-space-out-t-2'}>
        {report.news.map((newsItem, index) => (
          <article
            key={index}
            className={classNames({ 'stk-space-out-t-1': index !== 0 })}
          >
            <Grid>
              <Column>
                <div className={'stk-text-unimportant stk-text-small'}>
                  <time dateTime={newsItem.date}>{newsItem.date}</time>
                </div>
                <h3 className="stk-text-h4">
                  <a href={`${makeSecurityLink(security)}${newsItem.link}`}>
                    {newsItem.title}
                  </a>
                </h3>
              </Column>
              <Column shrink={'shrink'}>
                <span className={'stk-chip stk-chip--sm stk-hide-msm'}>
                  <span className={'stk-chip__label'}>{newsItem.type}</span>
                </span>
              </Column>
            </Grid>
          </article>
        ))}
      </Card>
    </>
  )
}
